<template>
  <div v-if="maxBidCreatedModal.lot.currency" class="ta-bid-created-modal-data ta-bid-created-modal-your-bid">
    <div class="ta-data-label">
      {{ maxBidCreatedModal.commissionBid ?  $t('Your Commission Bid') : $t('Your Max Bid') }}
    </div>
    <div class="ta-data-value">
      {{maxBidCreatedModal.bid.amount | asCurrency(maxBidCreatedModal.lot.currency.code)}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "YourMaxBid",
  computed: {
    ...mapState(['maxBidCreatedModal']),
  }
}
</script>

<style lang="scss" scoped>
</style>
